import * as types from './mutationTypes';

export default {
  [types.SET_ORGANIZATION](state, payload) {
    state.organization = payload;
  },
  [types.CLEAR_ORGANIZATION](state) {
    state.organization = null;
    localStorage.removeItem('t-org');
  },
  [types.SET_ORGANIZATIONS](state, organizations) {
    const orgReMapped = organizations.map((o) => [o.uuid, o]);
    const orgWithoutDuplicates = new Map(orgReMapped).values();
    state.organizations = [...orgWithoutDuplicates];
  },
  [types.CLEAR_ORGANIZATIONS](state) {
    state.organizations = null;
  },
  [types.SET_SEGMENTS](state, segments) {
    state.segments = segments;
  },
  [types.CLEAR_SEGMENTS](state) {
    state.segments = null;
  },
  [types.SET_EXPORT_RANGE](state, exportRange) {
    state.exportRange = exportRange;
  },
  [types.CLEAR_EXPORT_RANGE](state) {
    state.exportRange = null;
  },
  [types.SET_FIELD](state, { field, value }) {
    state.organization[field] = value;
  },
  [types.SET_EDIT_FIELD](state, { field, value }) {
    state.organizationEdit[field] = value;
  },
  [types.SET_ORGANIZATION_EDIT](state, organization) {
    state.organizationEdit = organization;
  },
  [types.CLEAR_ORGANIZATION_EDIT](state) {
    state.organizationEdit = {};
  },
  [types.SET_IDENTIFICATOR_CUSTOM](state, identificator) {
    state.identificatorCustom = identificator;
  },
  [types.SET_IDENTIFICATOR_CUSTOM_FIELD](state, { field, value }) {
    state.identificatorCustom[field] = value;
  },
  [types.CLEAR_IDENTIFICATOR_CUSTOM](state) {
    state.identificatorCustom = null;
  },
  [types.SET_ORGANIZATION_STORAGE](state) {
    setOrganizationStorage(state.organization, 't-org');
  },
  [types.SET_USER_DASHBOARD](state, dashboardUUID) {
    state.organization.user_dashboard = dashboardUUID;
    setOrganizationStorage(state.organization, 't-org');
  },
  [types.SET_USER_ADMIN_EMAIL](state, emails) {
    state.organization.users_admin_email = emails;
  },
};

function setOrganizationStorage(organization, local) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(local, JSON.stringify(organization));
  }
}
